import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { SyncRunsResponse } from "../model/SyncRun";
import { GetSyncRunsRequest } from "../request";

const GetSyncRunsApiService = async (
  request: GetSyncRunsRequest
): Promise<SyncRunsResponse> => {
  const { data } = await axios.get<SyncRunsResponse>(
    "integrations/runs/",
    { params: request }
  );
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGetSyncRunsApiService = (request: GetSyncRunsRequest) =>
  useQuery<SyncRunsResponse, AxiosError>(
    ["GetSyncRunsApiService", ...Object.values(request)],
    () => GetSyncRunsApiService(request),
    { keepPreviousData: true }
  );
